import { Action, State } from "../../types";
import { markBlockActive } from "./markBlockActive";
import { markCellActive } from "./markCellActive";
import { mouseDown } from "./mouseDown";
import { reOrderBlock } from "./reOrderBlock";
import { setPageSize } from "./setPageSize";
import { toggleShowReadingOrder } from "./toggleShowReadingOrder";
import { updateBlockText } from "./updateBlockText";
import { paginate} from "./paginate";
import { updateCellText } from "./updateCellText";
import { nextActiveBlock } from "./nextActiveBlock";
import { CountSubstrings } from "./countSubstrings";
import { replaceSubstrings } from "./replaceSubstrings";

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "MARK BLOCK ACTIVE":
      return markBlockActive(state, action);
    case "NEXT ACTIVE BLOCK": 
      return nextActiveBlock(state, action);
    case "MARK CELL ACTIVE":
      return markCellActive(state, action);
    case "MOUSE DOWN":
      return mouseDown(state, action);
    case "REORDER BLOCK":
      return reOrderBlock(state, action);
    case "TOGGLE SHOW READING ORDER":
      return toggleShowReadingOrder(state, action);
    case "UPDATE BLOCK TEXT":
      return updateBlockText(state, action);
    case "UPDATE CELL TEXT":
      return updateCellText(state, action);
    case "PAGINATE":
      return paginate(state, action);
    case "SET PAGE SIZE":
      return setPageSize(state, action);
    case "COUNT SUBSTRINGS":
      return CountSubstrings(state, action);
    case "REPLACE SUBSTRINGS":
      return replaceSubstrings(state, action);
  }
};
